import { getTeamColor } from "../chalkboard/helper";
import type { MatchDetailTeam } from "../../../utils/matchDetailColors";

export type PassMapSide = MatchDetailTeam;

export type PassMapStatus = Parameters<typeof getTeamColor>[0];

export function getPassMapTeamColor(
  status: PassMapStatus | undefined,
  team: PassMapSide
) {
  return getTeamColor(status, team);
}
